<template lang="pug">
	.packages-selection-stations
		.stations-selection.flex-col.space.center.align-center
			.font-big.upper.grey {{$tCaption('Package selection')}}
			.flex-row.wrap.center.align-center
				ListView.full-width(ref="listView", initialView="cards", :hideViewsSelection="true", :getTotal="(itemData) => itemData.total", :getItems="(itemData) => itemData.items", :getData="loadPackages", :columns="columns")
					template(v-slot:card="{ data }")
						.flex-row.justify.package-card.clickable(@click="(v) => toggleSelectedIdInArray(data.Oid, record.packages)", :class="{ selected: record.packages.indexOf(data.Oid) > -1 }")
							.flex-col.space
								.font-big {{data.Name}}
								.font-small.grey {{data.BrandName}}
							.flex-col.space.numbers
								.font-big {{data.TotalTargetImpressions}}
								.font-small.grey.upper {{$tCaption('impressions')}}
</template>

<script>
	import Data from 'app-core/Data';
	import ListView from 'app-core/ListView.vue';

	export default {
		translationCategory: 'proposal.PackagesSelectionStations',
		name: 'packages-selection',
		components: {ListView},
		mixins: [Data.mixin],
		props: ['data'],
		data() {
			return {
				record: this.data,
				columns: [
					{
						dataField: 'name',
						caption: () => this.$tCaption('Listing'),
						cellTemplate: 'listing-cell-template'
					},
					{ dataField: 'reach', caption: () => this.$tCaption('Reach'),  dataType: 'number', format: 'fixedPoint' },
					{ dataField: 'cpm', caption: () => this.$tCaption('CPM'),  dataType: 'number', format: { type: 'fixedPoint', precision: 2 }  },
					{ caption: '', width: 0 }
				],
			};
		},
		methods: {
			loadPackages(pageIndex, size) {
				return Data.getPackages(pageIndex, size).then(r => {
					if (__DEBUG__)
						console.info('Packages loaded', { r });
					return r;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.packages-selection-stations {
		@import "main/themes/generated/variables.base.scss";

		.package-card {
			border: 2px solid #f0f0f0;
			background: #f0f0f0;
			padding: 20px;
			width: 300px;
			transition: 0.3s;

			.numbers {
				text-align: right;
			}

			&:hover {
				border: 2px solid #f27649;
			}

			&.selected {
				border: 2px solid #f27649;
				background: #ffe2d7;
			}
		}
	}
</style>
